"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ForgotPasswordConfirmPage = exports.ForgotPasswordRequestPage = exports.RegisterConfirmPage = exports.RegisterRequestPage = exports.CountdownTimer = exports.ResponsiveList = exports.CartList = exports.CheckoutReviewPage = exports.CheckoutInfoPage = exports.CartPage = exports.withLoginRequired = exports.LoginForm = exports.LoginModal = exports.ProductVariants = exports.AntdAddressSetForm = exports.ArticleEditor = exports.RichTextImageModal = exports.RichTextEditor = exports.RichTextProvider = exports.RichTextPreview = exports.AdminResource = exports.BreadcrumbBar = exports.ProductListPage = exports.Generic = exports.Admin = exports.Discovery = exports.User = exports.Cart = exports.Storage = exports.JStorage = exports.ApiUtil = exports.Config = exports.Hello = exports.hello = void 0;
var Hello_1 = __importDefault(require("./Components/Hello"));
exports.Hello = Hello_1.default;
var Config = __importStar(require("./Config"));
exports.Config = Config;
var ApiUtil = __importStar(require("./Utils/ApiUtil"));
exports.ApiUtil = ApiUtil;
var JStorage = __importStar(require("./Actions/JStorage"));
exports.JStorage = JStorage;
var Storage = __importStar(require("./Actions/Storage"));
exports.Storage = Storage;
var Cart = __importStar(require("./Actions/Cart"));
exports.Cart = Cart;
var User = __importStar(require("./Actions/User"));
exports.User = User;
var Discovery = __importStar(require("./Actions/Discovery"));
exports.Discovery = Discovery;
var Admin = __importStar(require("./Actions/Admin"));
exports.Admin = Admin;
var ProductList_1 = __importDefault(require("./Templates/ProductList"));
exports.ProductListPage = ProductList_1.default;
var CartPage_1 = __importDefault(require("./Templates/CartPage"));
exports.CartPage = CartPage_1.default;
var CheckoutInfoPage_1 = __importDefault(require("./Templates/CheckoutInfoPage"));
exports.CheckoutInfoPage = CheckoutInfoPage_1.default;
var CheckoutReviewPage_1 = __importDefault(require("./Templates/CheckoutReviewPage"));
exports.CheckoutReviewPage = CheckoutReviewPage_1.default;
var CartList_1 = __importDefault(require("./Components/CartList"));
exports.CartList = CartList_1.default;
var BreadcrumbBar_1 = __importDefault(require("./Templates/ProductList/BreadcrumbBar"));
exports.BreadcrumbBar = BreadcrumbBar_1.default;
var Resource_1 = __importDefault(require("./Generic/Resource"));
var Form_1 = __importDefault(require("./Generic/Form"));
var AdminResource_1 = __importDefault(require("./Generators/AdminResource"));
exports.AdminResource = AdminResource_1.default;
var RichTextPreview_1 = __importDefault(require("./Components/RichTextPreview"));
exports.RichTextPreview = RichTextPreview_1.default;
var RichTextEditor_1 = __importStar(require("./Components/RichTextEditor"));
exports.RichTextEditor = RichTextEditor_1.default;
Object.defineProperty(exports, "RichTextProvider", {
  enumerable: true,
  get: function get() {
    return RichTextEditor_1.Provider;
  }
});
var ImageModal_1 = __importDefault(require("./Components/RichTextEditor/ImageModal"));
exports.RichTextImageModal = ImageModal_1.default;
var ArticleEditor_1 = __importDefault(require("./Components/ArticleEditor"));
exports.ArticleEditor = ArticleEditor_1.default;
var AntdAddressSetForm_1 = __importDefault(require("./Components/AntdAddressSetForm"));
exports.AntdAddressSetForm = AntdAddressSetForm_1.default;
var ProductVariants_1 = __importDefault(require("./Components/ProductVariants"));
exports.ProductVariants = ProductVariants_1.default;
var LoginModal_1 = __importDefault(require("./Components/LoginModal"));
exports.LoginModal = LoginModal_1.default;
var LoginForm_1 = __importDefault(require("./Components/LoginForm"));
exports.LoginForm = LoginForm_1.default;
var LoginRequired_1 = require("./Components/LoginRequired");
Object.defineProperty(exports, "withLoginRequired", {
  enumerable: true,
  get: function get() {
    return LoginRequired_1.withLoginRequired;
  }
});
var ResponsiveList_1 = __importDefault(require("./Components/ResponsiveList"));
exports.ResponsiveList = ResponsiveList_1.default;
var CountdownTimer_1 = __importDefault(require("./Components/CountdownTimer"));
exports.CountdownTimer = CountdownTimer_1.default;
var RequestPage_1 = __importDefault(require("./Templates/Register/RequestPage"));
exports.RegisterRequestPage = RequestPage_1.default;
var ConfirmPage_1 = __importDefault(require("./Templates/Register/ConfirmPage"));
exports.RegisterConfirmPage = ConfirmPage_1.default;
var RequestPage_2 = __importDefault(require("./Templates/ForgotPassword/RequestPage"));
exports.ForgotPasswordRequestPage = RequestPage_2.default;
var ConfirmPage_2 = __importDefault(require("./Templates/ForgotPassword/ConfirmPage"));
exports.ForgotPasswordConfirmPage = ConfirmPage_2.default;
function hello(message) {
  console.log("hello " + message);
  return message;
}
exports.hello = hello;
var Generic = {
  Resource: Resource_1.default,
  Form: Form_1.default
};
exports.Generic = Generic;